// import React, { useState, useEffect } from "react";

// const NotificationPopup = () => {
//   const [notifications, setNotifications] = useState([]);

//   // ✅ Load notifications from localStorage on mount
//   useEffect(() => {
//     const storedNotifications =
//       JSON.parse(localStorage.getItem("notifications")) || [];
//     setNotifications(storedNotifications);
//   }, []);

//   // ✅ Mark notification as read and remove it from the list
//   const markAsRead = (index) => {
//     const updatedNotifications = [...notifications];
//     updatedNotifications.splice(index, 1);
//     setNotifications(updatedNotifications);
//     localStorage.setItem("notifications", JSON.stringify(updatedNotifications));
//   };

//   return (
//     <div
//       style={{
//         position: "absolute",
//         top: "50px",
//         right: "10px",
//         width: "300px",
//         background: "white",
//         border: "1px solid gray",
//         padding: "10px",
//         borderRadius: "5px",
//         boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
//       }}
//     >
//       <h3>🔔 Notifications</h3>
//       {notifications.length === 0 ? (
//         <p>No new notifications</p>
//       ) : (
//         notifications.map((notification, index) => (
//           <div
//             key={index}
//             style={{ padding: "5px", borderBottom: "1px solid lightgray" }}
//           >
//             <strong>{notification.title}</strong>
//             <p>{notification.body}</p>
//             <small>{new Date(notification.timestamp).toLocaleString()}</small>
//             <button
//               onClick={() => markAsRead(index)}
//               style={{ marginLeft: "10px", cursor: "pointer" }}
//             >
//               Mark as Read
//             </button>
//           </div>
//         ))
//       )}
//     </div>
//   );
// };

// export default NotificationPopup;
import React, { useState, useEffect } from "react";

const NotificationPopup = ({ onClose }) => {
  const [notifications, setNotifications] = useState([]);

  // ✅ Load notifications from localStorage
  useEffect(() => {
    const storedNotifications =
      JSON.parse(localStorage.getItem("notifications")) || [];
    setNotifications(storedNotifications);
  }, []);

  // ✅ Mark notifications as read and clear count
  useEffect(() => {
    localStorage.setItem("unreadCount", "0"); // Reset unread count
  }, []);

  const markAsRead = (index) => {
    const updatedNotifications = [...notifications];
    updatedNotifications.splice(index, 1);
    setNotifications(updatedNotifications);
    localStorage.setItem("notifications", JSON.stringify(updatedNotifications));
  };

  return (
    <div className="notify-box">
      <h4 className="border-bottom pb-2"> Notifications</h4>
      <div className="msg-scroll">
        {notifications.length === 0 ? (
          <p>No new notifications</p>
        ) : (
          notifications.map((notification, index) => (
            <div className=" pb-4 box-col" key={index}>
              <div>
                <strong>{notification.title}</strong>
              </div>
              <p>{notification.body}</p>
              <div className="d-flex gap-2">
                <div>{new Date(notification.timestamp).toLocaleString()}</div>
                <button
                  onClick={() => markAsRead(index)}
                  className="btn btn-primary"
                >
                  Mark as Read
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="border-top mt-2">
        <button onClick={onClose} className="btn secnd-btn mt-2">
          Close
        </button>
      </div>
    </div>
  );
};

export default NotificationPopup;
